'use client';

import StyledButton from "@/app/features/shared/__to_be_integrated/StyledButton";
import { PictureAsPdf } from "@mui/icons-material";

export default function HistoryEventPdfLink({
    eventTitle,
    url,
}: {
    eventTitle: string;
    url: string;
}) {
    return (
        <StyledButton
            component="a"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`PDF zu ${eventTitle} in neuem Tab öffnen`}
            startIcon={<PictureAsPdf fontSize="large" />}
        >
            Mehr erfahren (PDF)
        </StyledButton>
    );
}
